import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Small public "N citizens signed" ticker — used on the landing.
export default function PledgeTicker() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await fetch(`${API}/pledge/stats`);
        if (!r.ok) return;
        const j = await r.json();
        if (mounted) setCount(j.count ?? 0);
      } catch {
        /* ignore */
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  if (count === null) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      data-testid="public-pledge-ticker"
      className="mt-8 inline-flex items-center gap-3 border border-white/15 px-4 py-2"
    >
      <span className="h-2 w-2 animate-pulse bg-rebellion" />
      <span className="font-mono text-[0.65rem] uppercase tracking-[0.3em] text-white/60">
        <span className="text-paper" data-testid="public-pledge-count">
          {count.toLocaleString("en-US")}
        </span>{" "}
        {count === 1 ? "citizen has" : "citizens have"} signed the pledge
      </span>
    </motion.div>
  );
}
